/*
 * @Author: Chao Yang
 * @Date: 2020-10-19 15:42:41
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-10-20 09:18:35
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdSelectButtonComponent } from './ad-select-button.component';

@NgModule({
  declarations: [AdSelectButtonComponent],
  imports: [CommonModule, FormsModule],
  exports: [AdSelectButtonComponent],
})
export class AdSelectButtonModule {}
